{
  "journalAudit.action.dependency.removed": "Cross-project dependency removed",
  "v7.planification.backlog.aucun_choisi": "Choose a top-level item in the list.",
  "v7.planification.backlog.cadrer": "Frame then specify",
  "v7.planification.backlog.choisi": "Selected item",
  "v7.planification.backlog.description": "Description",
  "v7.planification.backlog.executant_disponible": "Processing service available.",
  "v7.planification.backlog.executant_indisponible": "Processing service unavailable: the job will wait for it.",
  "v7.planification.backlog.executant_quoi": "the worker status",
  "v7.planification.backlog.flux_aucun": "No job started from this screen.",
  "v7.planification.backlog.flux_en_cours": "Job running.",
  "v7.planification.backlog.flux_en_echec": "Job failed.",
  "v7.planification.backlog.flux_en_file": "Job queued.",
  "v7.planification.backlog.flux_erreur": "The job cannot be tracked right now.",
  "v7.planification.backlog.flux_flux_coupe_reconnecter": "Tracking stopped before the job finished.",
  "v7.planification.backlog.flux_termine": "Job finished.",
  "v7.planification.backlog.generer": "Generate the next level",
  "v7.planification.backlog.job_lance": "Job started: its progress is shown below.",
  "v7.planification.backlog.lancer": "Launch a top-level item",
  "v7.planification.backlog.liste": "Launched top-level items",
  "v7.planification.backlog.liste_quoi": "the top-level items",
  "v7.planification.backlog.liste_vide": "No top-level item has been launched yet.",
  "v7.planification.backlog.non_accessibles": "{{n}} item(s) from projects not open to you: counted without detail.",
  "v7.planification.backlog.objectif_defini": "objective set",
  "v7.planification.backlog.objectif_non_defini": "no objective",
  "v7.planification.backlog.ouvrir_fiche": "Open the record",
  "v7.planification.backlog.ouvrir_projet": "Open the target project",
  "v7.planification.backlog.produits_quoi": "the produced items",
  "v7.planification.backlog.produits_valeur": "{{total}} item(s) produced for “{{titre}}”.",
  "v7.planification.backlog.produits_vide": "No item produced (a framing awaits review).",
  "v7.planification.backlog.projet_cible": "Target project",
  "v7.planification.backlog.reconnecter": "Reconnect tracking",
  "v7.planification.backlog.resultat_echec": "The job failed: start it again after checking the target project.",
  "v7.planification.backlog.resultat_termine": "The job produced its result.",
  "v7.planification.backlog.suivi": "Job progress",
  "v7.planification.backlog.titre": "Programme backlog",
  "v7.planification.backlog.titre_champ": "Title",
  "v7.planification.backlog.validation_projet": "Choose the target project.",
  "v7.planification.backlog.validation_titre": "The title must have at least 3 characters.",
  "v7.planification.code.ACCESS_DENIED": "You are not a member of this programme.",
  "v7.planification.code.AI_STOPPED": "AI is stopped for this organisation: no job can be started.",
  "v7.planification.code.ALREADY_EXISTS": "This dependency is already declared.",
  "v7.planification.code.CONTEXTE_INCOMPLET": "The context needed to check rights is incomplete.",
  "v7.planification.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v7.planification.code.GARDE_DROIT_ABSENTE": "This operation declares no rights guard: it is refused.",
  "v7.planification.code.MISSING_PARAMETER": "A required parameter is missing.",
  "v7.planification.code.NOT_FOUND": "Project or dependency not found in the programme.",
  "v7.planification.code.PROJECT_WRITE_REQUIRED": "A write role in the target project is required.",
  "v7.planification.code.RESOURCE_UNAVAILABLE": "This object does not exist in the programme or is not accessible to you.",
  "v7.planification.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v7.planification.code.VALIDATION_ERROR": "One of the projects is not in the programme, or a field is out of range.",
  "v7.planification.code.WORKSPACE_ARCHIVED": "The consuming project is archived: it is read-only.",
  "v7.planification.dependances.artefact": "Awaited artefact",
  "v7.planification.dependances.aucune": "Choose a dependency in the list.",
  "v7.planification.dependances.choisie": "Selected dependency",
  "v7.planification.dependances.choisir": "View",
  "v7.planification.dependances.confirmer_retrait": "I confirm the removal: {{consommateur}} will no longer await anything from {{fournisseur}} for this artefact.",
  "v7.planification.dependances.consommateur": "Consuming project",
  "v7.planification.dependances.declarer": "Declare a dependency",
  "v7.planification.dependances.echeance": "Proposed date",
  "v7.planification.dependances.etat": "Status",
  "v7.planification.dependances.etat_attendue": "awaited",
  "v7.planification.dependances.etat_bloquante": "blocking",
  "v7.planification.dependances.etat_en_retard": "late",
  "v7.planification.dependances.etat_satisfaite": "satisfied",
  "v7.planification.dependances.filtre_etat": "Status",
  "v7.planification.dependances.filtre_projet": "Project",
  "v7.planification.dependances.fournisseur": "Supplying project",
  "v7.planification.dependances.ligne": "{{consommateur}} awaits “{{artefact}}” from {{fournisseur}}",
  "v7.planification.dependances.liste": "Dependencies",
  "v7.planification.dependances.liste_quoi": "the dependencies",
  "v7.planification.dependances.retiree": "Dependency removed.",
  "v7.planification.dependances.retirer": "Remove",
  "v7.planification.dependances.sans_echeance": "no date",
  "v7.planification.dependances.titre": "Dependencies between programme projects",
  "v7.planification.dependances.tous": "All",
  "v7.planification.dependances.vide": "No dependency between the programme projects.",
  "v7.planification.dependances.vide_filtre": "No dependency matches the filter.",
  "v7.planification.dialogue.annuler": "Cancel",
  "v7.planification.dialogue.artefact": "Awaited artefact",
  "v7.planification.dialogue.artefact_aide": "Fragment of the artefact path (3 to 300 characters), for example api-contract.md.",
  "v7.planification.dialogue.attendu": "Awaited project (supplier)",
  "v7.planification.dialogue.aucun_projet": "At least two visible projects are needed in the programme.",
  "v7.planification.dialogue.choisir": "Choose…",
  "v7.planification.dialogue.consommateur": "Project that waits (consumer)",
  "v7.planification.dialogue.declaree": "Dependency declared.",
  "v7.planification.dialogue.declarer": "Declare the dependency",
  "v7.planification.dialogue.projets_quoi": "the programme projects",
  "v7.planification.dialogue.titre": "Declare a dependency between projects",
  "v7.planification.dialogue.validation_artefact": "The awaited artefact must have 3 to 300 characters.",
  "v7.planification.dialogue.validation_meme_projet": "A project cannot depend on itself.",
  "v7.planification.dialogue.validation_projets": "Choose both projects.",
  "v7.planification.ecran_non_realise": "“{{ecran}}” leads to a screen that is not built yet.",
  "v7.planification.element.avancement": "Progress",
  "v7.planification.element.avancement_valeur": "{{faits}} / {{total}} done",
  "v7.planification.element.contribution_valeur": "{{faits}} / {{total}} items done",
  "v7.planification.element.contributions": "Project contributions",
  "v7.planification.element.contributions_non_visibles": "{{n}} contribution(s) from a project not visible to you: reported without detail.",
  "v7.planification.element.contributions_quoi": "the contributions",
  "v7.planification.element.definir_objectif": "Set the objective",
  "v7.planification.element.dependances": "Dependencies",
  "v7.planification.element.generer_enfants": "Generate child items",
  "v7.planification.element.geste_non_raccorde": "“{{geste}}” has no operation yet: start it from the programme backlog.",
  "v7.planification.element.lien_dependances": "Programme dependencies",
  "v7.planification.element.niveau": "Level",
  "v7.planification.element.objectif": "Objective",
  "v7.planification.element.panneau": "Top-level item",
  "v7.planification.element.preparer_document": "Prepare the document",
  "v7.planification.element.quoi": "the item",
  "v7.planification.element.retour": "Back to programme items",
  "v7.planification.element.sans_contribution": "No project contributes yet.",
  "v7.planification.element.sans_dependance": "No dependency between its projects.",
  "v7.planification.element.sans_element": "No item is designated: open this record from the programme backlog.",
  "v7.planification.element.sans_objectif": "No objective set.",
  "v7.planification.element.titre": "Programme item",
  "v7.planification.element.titre_champ": "Title",
  "v7.planification.etat.chargement": "Loading {{quoi}}…",
  "v7.planification.etat.en_cours": "Sending…",
  "v7.planification.etat.erreur": "{{quoi}}: cannot be read right now.",
  "v7.planification.etat.introuvable": "{{quoi}}: not found in this programme.",
  "v7.planification.etat.reessayer": "Retry",
  "v7.planification.etat.refus": "{{quoi}}: you do not have access to this information.",
  "v7.planification.geste.erreur": "The action did not complete. Try again in a moment.",
  "v7.planification.projets_non_visibles": "{{n}} programme project(s) are not visible to you: counted without detail.",
  "v7.planification.sans_programme": "No programme is selected: choose one in the context selector.",
  "v7.planification.vue.ensemble": "Overview",
  "v7.planification.vue.ensemble_quoi": "the programme overview",
  "v7.planification.vue.membres": "Programme members",
  "v7.planification.vue.membres_quoi": "the members",
  "v7.planification.vue.membres_vide": "No member.",
  "v7.planification.vue.nom": "Programme",
  "v7.planification.vue.objectif": "Objective",
  "v7.planification.vue.objectif_registre": "Objective and risk register",
  "v7.planification.vue.par_element": "Progress by top-level item",
  "v7.planification.vue.par_element_quoi": "progress by item",
  "v7.planification.vue.par_element_vide": "No top-level item in the open projects.",
  "v7.planification.vue.par_projet": "Progress by project",
  "v7.planification.vue.par_projet_quoi": "project progress",
  "v7.planification.vue.par_projet_vide": "No project attached to the programme.",
  "v7.planification.vue.projet_valeur": "{{faits}} / {{total}} items done",
  "v7.planification.vue.projets": "Projects",
  "v7.planification.vue.sans_objectif": "No objective set.",
  "v7.planification.vue.sans_version": "no release in preparation",
  "v7.planification.vue.sante": "Lowest health",
  "v7.planification.vue.titre": "Programme overview",
  "v7.planification.vue.train": "Programme train",
  "v7.planification.vue.train_quoi": "the train",
  "v7.planification.vue.train_vide": "No project in the train."
}
